<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Configuración</p>
              <argon-button
                color="success"
                size="sm"
                class="ms-auto"
                @click="save"
                :disabled="isSaving"
              >
                Guardar
              </argon-button>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información de la empresa</p>
            <div class="row">
              <div class="col-md-12">
                <label class="form-control-label">Nombre de la empresa</label>
                <argon-input type="text" v-model="form.company_name" placeholder="Ej: Mi Empresa" />
              </div>
              <div class="col-md-6">
                <label class="form-control-label">NIT</label>
                <argon-input
                  type="text"
                  v-model="form.nit"
                  placeholder="Ej: 900123456-7"
                />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">Descripción</label>
                <textarea
                  class="form-control"
                  v-model="form.description"
                  rows="3"
                  placeholder="Descripción o notas"
                ></textarea>
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Correo electrónico</label>
                <argon-input type="email" v-model="form.email" placeholder="contacto@empresa.com" />
              </div>
              <div class="col-md-6">
                <label class="form-control-label">Teléfono</label>
                <argon-input type="text" v-model="form.phone" placeholder="+57 300 123 4567" />
              </div>
              <div class="col-md-12">
                <label class="form-control-label">Dirección</label>
                <argon-input type="text" v-model="form.address" placeholder="Dirección física" />
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <div class="d-flex align-items-center">
                  <label class="form-control-label mb-0">Manejar producción</label>
                  <div class="form-check form-switch ms-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.manage_production"
                    />
                    <label class="form-check-label">Activar</label>
                  </div>
                </div>
                <p class="text-sm text-muted mt-2 mb-0">
                  Si está desactivado, se ocultan del menú lateral: Modelos, Producción e Inventario.
                </p>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <div class="d-flex align-items-center">
                  <label class="form-control-label mb-0">Beneficios de tareas</label>
                  <div class="form-check form-switch ms-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.benefits_of_tasks"
                    />
                    <label class="form-check-label">Activar</label>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Integración Siigo</p>
                <div class="d-flex align-items-center">
                  <label class="form-control-label mb-0">Activar sincronización Siigo</label>
                  <div class="form-check form-switch ms-3">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      v-model="form.siigo_sync_enabled"
                    />
                    <label class="form-check-label">Activar</label>
                  </div>
                </div>
                <p class="text-sm text-muted mt-2 mb-0">
                  El access key se configura en el servidor (.env). Desde aquí solo indica usuario y Partner ID.
                </p>

                <div v-if="form.siigo_sync_enabled" class="row mt-3">
                  <div class="col-md-6">
                    <label class="form-control-label">Usuario Siigo</label>
                    <argon-input
                      type="text"
                      v-model="form.siigo_username"
                      placeholder="Ej: correo@empresa.com"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Partner ID</label>
                    <argon-input
                      type="text"
                      v-model="form.siigo_partner_id"
                      placeholder="Ej: miStockLbp"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Último token generado</label>
                    <argon-input
                      type="text"
                      :model-value="siigoTokenGeneratedLabel"
                      readonly
                      placeholder="Aún no se ha generado token"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Filtrar productos desde (opcional)</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="form.siigo_products_created_start"
                    />
                    <p class="text-xs text-muted mt-2 mb-0">
                      Si se define, la sync usará <code>created_start</code> en la API de Siigo.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-12 mt-3">
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Logos (opcional)</p>
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label">Ícono / Logo claro</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="image/*"
                      @change="onLogoLightChange"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label">Ícono / Logo oscuro</label>
                    <input
                      type="file"
                      class="form-control"
                      accept="image/*"
                      @change="onLogoDarkChange"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4" v-if="form.siigo_sync_enabled">
        <div class="card">
          <div class="card-header pb-0">
            <p class="mb-0 text-uppercase text-sm">Webhooks Siigo</p>
          </div>
          <div class="card-body">
            <p class="text-xs text-muted">
              Suscripciones a eventos de Siigo (<code>POST /v1/webhooks</code>).
            </p>

            <div class="mb-3">
              <label class="form-control-label">Application ID</label>
              <argon-input
                type="text"
                v-model="webhookForm.application_id"
                placeholder="Siigo"
              />
            </div>

            <div class="mb-3">
              <label class="form-control-label">Topic</label>
              <select v-model="webhookForm.topic" class="form-select form-select-sm">
                <option
                  v-for="topic in siigoWebhookTopics"
                  :key="topic.value"
                  :value="topic.value"
                >
                  {{ topic.label }}
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-control-label">URL del webhook</label>
              <argon-input
                type="url"
                v-model="webhookForm.url"
                placeholder="https://tu-dominio.com/api/siigo/webhooks/products"
              />
            </div>

            <argon-button
              color="info"
              size="sm"
              class="w-100"
              :disabled="webhookSaving"
              @click="createWebhook"
            >
              <i
                :class="webhookSaving ? 'fas fa-sync fa-spin me-1' : 'fas fa-plus me-1'"
              ></i>
              Crear suscripción
            </argon-button>

            <hr class="horizontal dark my-3" />

            <p class="text-uppercase text-xs text-muted mb-2">Suscripciones registradas</p>

            <div v-if="webhookLoading" class="text-center py-3 text-muted text-sm">
              <i class="fas fa-spinner fa-spin"></i> Cargando...
            </div>

            <p v-else-if="!siigoWebhooks.length" class="text-sm text-muted mb-0">
              No hay webhooks registrados.
            </p>

            <ul v-else class="list-group list-group-flush webhook-list">
              <li
                v-for="hook in siigoWebhooks"
                :key="hook.id"
                class="list-group-item px-0 py-2 border-0 border-bottom"
              >
                <div class="d-flex justify-content-between align-items-start gap-2">
                  <div class="min-w-0">
                    <p class="text-xs text-muted mb-0 text-truncate" :title="hook.id">
                      {{ hook.id }}
                    </p>
                    <p class="text-sm mb-0 fw-bold">{{ hook.topic }}</p>
                    <p class="text-xs text-muted mb-0 text-break">{{ hook.url }}</p>
                  </div>
                  <button
                    type="button"
                    class="btn btn-link text-danger p-0 ms-1 flex-shrink-0"
                    title="Eliminar webhook"
                    :disabled="webhookDeletingId === hook.id"
                    @click="deleteWebhook(hook.id)"
                  >
                    <i
                      :class="webhookDeletingId === hook.id ? 'fas fa-sync fa-spin' : 'fas fa-trash'"
                    ></i>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Swal from "sweetalert2";
import settingsService from "@/services/settings.service";

export default {
  name: "Settings",
  components: {
    ArgonInput,
    ArgonButton,
  },
  data() {
    return {
      isSaving: false,
      form: {
        company_name: "",
        nit: "",
        description: "",
        email: "",
        phone: "",
        address: "",
        benefits_of_tasks: false,
        manage_production: true,
        siigo_sync_enabled: false,
        siigo_username: "",
        siigo_partner_id: "",
        siigo_products_created_start: "",
        siigo_token_generated_at: null,
      },
      logoLightFile: null,
      logoDarkFile: null,
      webhookLoading: false,
      webhookSaving: false,
      webhookDeletingId: null,
      siigoWebhooks: [],
      webhookForm: {
        application_id: "Siigo",
        topic: "public.siigoapi.products.create",
        url: "",
      },
      siigoWebhookTopics: [
        { value: "public.siigoapi.products.create", label: "Productos — crear" },
        { value: "public.siigoapi.products.update", label: "Productos — actualizar" },
        { value: "public.siigoapi.products.delete", label: "Productos — eliminar" },
        { value: "public.siigoapi.invoices.create", label: "Facturas — crear" },
        { value: "public.siigoapi.invoices.update", label: "Facturas — actualizar" },
      ],
    };
  },
  computed: {
    siigoTokenGeneratedLabel() {
      if (!this.form.siigo_token_generated_at) return "";
      const date = new Date(this.form.siigo_token_generated_at);
      if (Number.isNaN(date.getTime())) return String(this.form.siigo_token_generated_at);
      return date.toLocaleString("es-CO");
    },
  },
  mounted() {
    this.loadSettings();
    this.loadSiigoWebhooks();
  },
  methods: {
    async loadSiigoWebhooks() {
      this.webhookLoading = true;
      try {
        const response = await settingsService.getSiigoWebhooks();
        this.siigoWebhooks = Array.isArray(response.data?.webhooks)
          ? response.data.webhooks
          : [];
      } catch (error) {
        console.error("Error al cargar webhooks Siigo:", error);
        this.siigoWebhooks = [];
      } finally {
        this.webhookLoading = false;
      }
    },
    async createWebhook() {
      if (!this.webhookForm.url?.trim()) {
        await Swal.fire("URL requerida", "Indique la URL del webhook.", "warning");
        return;
      }

      this.webhookSaving = true;
      try {
        const response = await settingsService.createSiigoWebhook({
          application_id: this.webhookForm.application_id || "Siigo",
          topic: this.webhookForm.topic,
          url: this.webhookForm.url.trim(),
        });
        this.siigoWebhooks = response.data?.webhooks || [];
        await Swal.fire(
          "Webhook creado",
          response.data?.message || "Suscripción registrada en Siigo.",
          "success"
        );
      } catch (error) {
        await Swal.fire(
          "Error",
          error?.response?.data?.message || "No se pudo crear el webhook.",
          "error"
        );
      } finally {
        this.webhookSaving = false;
      }
    },
    async deleteWebhook(id) {
      const confirm = await Swal.fire({
        title: "Eliminar webhook",
        text: "¿Eliminar esta suscripción en Siigo?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
        confirmButtonColor: "#d33",
      });

      if (!confirm.isConfirmed) {
        return;
      }

      this.webhookDeletingId = id;
      try {
        const response = await settingsService.deleteSiigoWebhook(id);
        this.siigoWebhooks = response.data?.webhooks || [];
        await Swal.fire(
          "Eliminado",
          response.data?.message || "Webhook eliminado correctamente.",
          "success"
        );
      } catch (error) {
        await Swal.fire(
          "Error",
          error?.response?.data?.message || "No se pudo eliminar el webhook.",
          "error"
        );
      } finally {
        this.webhookDeletingId = null;
      }
    },
    async loadSettings() {
      try {
        const response = await this.$store.dispatch("settings/get");
        const data = response.data;
        this.form = {
          company_name: data.company_name || "",
          nit: data.nit || "",
          description: data.description || "",
          email: data.email || "",
          phone: data.phone || "",
          address: data.address || "",
          benefits_of_tasks: !!data.benefits_of_tasks,
          manage_production: data.manage_production !== false && data.manage_production !== 0 && data.manage_production !== '0',
          siigo_sync_enabled: !!data.siigo_sync_enabled,
          siigo_username: data.siigo_username || "",
          siigo_partner_id: data.siigo_partner_id || "",
          siigo_products_created_start: data.siigo_products_created_start
            ? String(data.siigo_products_created_start).slice(0, 10)
            : "",
          siigo_token_generated_at: data.siigo_token_generated_at || null,
        };
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
        await Swal.fire("Error", "Error al cargar la configuración", "error");
      }
    },
    onLogoLightChange(event) {
      this.logoLightFile = event.target.files?.[0] || null;
    },
    onLogoDarkChange(event) {
      this.logoDarkFile = event.target.files?.[0] || null;
    },
    async save() {
      this.isSaving = true;
      try {
        const formData = new FormData();
        formData.append("company_name", this.form.company_name);
        formData.append("nit", this.form.nit || "");
        formData.append("description", this.form.description);
        formData.append("email", this.form.email);
        formData.append("phone", this.form.phone);
        formData.append("address", this.form.address);
        formData.append("benefits_of_tasks", this.form.benefits_of_tasks ? "1" : "0");
        formData.append("manage_production", this.form.manage_production ? "1" : "0");
        formData.append("siigo_sync_enabled", this.form.siigo_sync_enabled ? "1" : "0");
        formData.append("siigo_username", this.form.siigo_username || "");
        formData.append("siigo_partner_id", this.form.siigo_partner_id || "");
        formData.append(
          "siigo_products_created_start",
          this.form.siigo_products_created_start || ""
        );
        if (this.logoLightFile) {
          formData.append("logo_path", this.logoLightFile);
        }
        if (this.logoDarkFile) {
          formData.append("logo_path_dark", this.logoDarkFile);
        }

        await this.$store.dispatch("settings/save", formData);
        await Swal.fire("Éxito", "Configuración guardada correctamente", "success");
        this.logoLightFile = null;
        this.logoDarkFile = null;
        document.querySelectorAll('input[type="file"]').forEach((el) => (el.value = ""));
      } catch (error) {
        console.error("Error al guardar:", error);
        await Swal.fire(
          "Error",
          error?.response?.data?.message || "Error al guardar la configuración",
          "error"
        );
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped>
.webhook-list .list-group-item:last-child {
  border-bottom: none !important;
}
</style>
